import { Component, OnInit } from '@angular/core';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { ImprestService } from '../services/imprest.service';
import { IImprestVendor } from '../models/imprest-vendor.model';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { ManageImprestVendorsComponent } from './manage-imprest-vendors/manage-imprest-vendors.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'imprest-vendors',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatCheckboxModule],
  templateUrl: './imprest-vendors.component.html',
  styleUrl: './imprest-vendors.component.scss'
})
export class ImprestVendorsComponent implements OnInit {

  user: ILoggedInUser;
  isAdmin: boolean;
  dataSource: IImprestVendor[] = [];
  loading: boolean = true;
  displayedColumns: string[] = ['number', 'currency', 'vendor', 'payee'];

  constructor(private userService: LoggedInUserService,
    private imprestService: ImprestService,
    private modal: MatDialog) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.imprestService.getImprestVendors().subscribe(
          data => {
            this.dataSource = data;
            this.loading = false;
          }
        );
      } else {
        this.loading = false;
      }
    });
  }

  openDialog(imprestVendor: IImprestVendor): void {
    this.modal.open(ManageImprestVendorsComponent, {
      data: imprestVendor
    });

    this.modal.afterAllClosed.subscribe(() => {
      this.loadData();
    });
  }
}
